import React from 'react';
import { ArrowRight } from 'lucide-react';

const HERO_IMAGE = "/images/hero/hero-banner.webp";

export const HeroSection = () => {
  const scrollToProducts = () => {
    const productsSection = document.getElementById('products-section');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      data-testid="hero-section"
      className="relative w-full overflow-hidden"
      style={{ height: '85vh', minHeight: '600px' }}
    >
      {/* Background Image - Right side */}
      <div 
        data-testid="hero-background"
        className="absolute inset-0"
        style={{ 
          backgroundImage: `url(${HERO_IMAGE})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center right',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#2C4A3E'
        }}
      />

      {/* Left side dark gradient overlay */}
      <div 
        data-testid="hero-overlay"
        className="absolute inset-0"
        style={{ 
          background: 'linear-gradient(to right, #1A3D36 0%, #1A3D36 25%, rgba(26, 61, 54, 0.9) 35%, rgba(26, 61, 54, 0.5) 45%, rgba(26, 61, 54, 0.1) 55%, transparent 65%)'
        }}
      />

      {/* Content Layer */}
      <div 
        data-testid="hero-content"
        className="relative z-10 h-full flex items-center"
      >
        <div className="w-full px-8 lg:px-16 xl:px-24">
          <div className="max-w-[420px]">
            {/* Headline */}
            <h1 
              data-testid="hero-headline"
              className="font-serif font-medium mb-6"
              style={{ 
                color: '#E8E6E1',
                fontSize: 'clamp(36px, 4.5vw, 52px)',
                lineHeight: '1.1'
              }}
            >
              Build Your Protocol.<br />
              Optimize Your Biology.
            </h1>

            {/* Subtext */}
            <p 
              data-testid="hero-subtext"
              className="text-base leading-relaxed mb-5"
              style={{ color: '#B8C4BE' }}
            >
              Precision-formulated peptides, supplements, and nutrition systems designed to support recovery, performance, and long-term health.
            </p>

            {/* Trust Line */}
            <p 
              data-testid="hero-trust-line"
              className="text-sm font-normal mb-8"
              style={{ color: '#8A9B90' }}
            >
              Sterile. Tested. Trusted.
            </p>

            {/* CTA Buttons */}
            <div className="flex items-center gap-3">
              {/* Primary CTA - Shop Products (text style) */}
              <button
                data-testid="cta-shop-products"
                onClick={scrollToProducts}
                className="inline-flex items-center gap-2 px-5 py-3 text-sm font-medium transition-all duration-200 hover:opacity-80"
                style={{ 
                  backgroundColor: 'transparent', 
                  color: '#E8E6E1'
                }}
              >
                Shop Products
                <ArrowRight size={15} strokeWidth={2} />
              </button>

              {/* Secondary CTA - Explore Stacks (bordered button) */}
              <button
                data-testid="cta-explore-stacks"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium transition-all duration-200 hover:bg-white hover:bg-opacity-10"
                style={{ 
                  backgroundColor: '#0F2820', 
                  color: '#E8E6E1',
                  border: '1px solid #3D5A4F',
                  borderRadius: '2px'
                }}
              >
                Explore Stacks
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
